// extracted by mini-css-extract-plugin
export default {"PaymentAgreementInfo":"dPNYd","hidden":"lYVDX","skeleton-progress":"xAWp1"};